<div class="c-slider" #slider></div>
<div
    *ngFor="let item of items; let i = index"
    class="c-tabs__item"
    [class.c-tabs__item--active]="item.active"
    [class.c-tabs__item--disabled]="item.disabled"
    (click)="itemClicked(item, i, $event)"
    #tabItem
>
    <ihd-icon
        *ngIf="item.icon"
        [name]="item.icon"
        class="{{ item.iconClass }}"
    ></ihd-icon>
    <span class="c-tabs__label" [attr.title]="item.label">{{
        item.label
    }}</span>
    <span
        class="c-badge c-badge--no-padding ml-1"
        *ngIf="item.badge"
        [class.c-badge--danger]="
            item.badge?.type === 'danger' || !item.badge?.type
        "
        [class.c-badge--info]="item.badge?.type === 'info'"
        [class.c-badge--warning]="item.badge?.type === 'warning'"
    >
        {{ item.badge.count }}
    </span>
</div>
